export default __webpack_public_path__ + "static/open-sans-latin-700-normal-05e19c4acc0834e67a3becda1d6340cb.woff2";